import React from 'react';
import { DialogActions } from '@mui/material';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import CreditLineStatus from '../../../../../../../../../common/creditLineStatus';

const ShoppingCartRejected = (props: any) => {
  const { setOpenShoppingCart, openRequest } = props;

  return (
    <div>
      <div>
        <CreditLineStatus openRequest={openRequest} audienceType="sent" />
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    </div>
  );
};

export default ShoppingCartRejected;
